/**
 * 預購頁面共用工具（member-frontend 專用，與 @pos/shared preorderUtils 區隔）
 */

const WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];

/**
 * 取得台北時區今天的日期字串 YYYY-MM-DD
 */
export function getTodayTaipeiDateStr(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Taipei' });
}

/**
 * 從 YYYY-MM-DD 減去 N 天，回傳 YYYY-MM-DD
 */
export function subDaysFromDateStr(dateStr: string, days: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  date.setDate(date.getDate() - days);
  const yy = date.getFullYear();
  const mm = date.getMonth() + 1;
  const dd = date.getDate();
  return `${yy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
}

/**
 * 將 ISO 或台北時間字串格式化成「日期 + 時間」顯示（例：2026/2/4 00:00）
 * 用於檔期區間 startsAtTaipei / endsAtTaipei；顯示為 Asia/Taipei
 */
export function formatDateTimeRangeLabel(isoOrDateStr: string): string {
  const date = new Date(isoOrDateStr);
  if (Number.isNaN(date.getTime())) return isoOrDateStr;
  return date.toLocaleString('sv-SE', {
    timeZone: 'Asia/Taipei',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

/**
 * 將 YYYY-MM-DD 轉成顯示用標籤（例：2/1(六)）
 */
export function formatPickupDateLabel(dateStr: string): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const weekday = WEEKDAYS[date.getDay()];
  return `${month}/${day}(${weekday})`;
}

export type PickupOptionItem = { value: string; label: string };

/**
 * 生成未來 5 天的日期選項（無 campaign 或非例行檔期時使用）
 */
export function generatePickupDateOptions(): PickupOptionItem[] {
  const options: PickupOptionItem[] = [];
  const today = new Date();

  for (let i = 1; i <= 5; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekday = WEEKDAYS[date.getDay()];

    const value = `${date.getFullYear()}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const label = `${month}/${day}(${weekday})`;

    options.push({ value, label });
  }

  return options;
}
